import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import ShubhamImage from '../../assest/images/Shubham1.png'
import CustomDropdown from '../common/CustomDropdown';
import eye from '../../assest/images/eye.png';
import Icon3 from '../../assest/images/Icon3.png';
import Icon8 from '../../assest/images/Icon8.png'
import { UserContext } from '../common/UserContext';
import config from "../../envconfig";

const ShipmentReturnList = () => {
  // const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode } = useParams();
  const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId, } = useContext(UserContext);

  useEffect(() => {
    sessionStorage.setItem('UM_GroupId', UM_GroupId);
    sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
    sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
    sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
    sessionStorage.setItem('UM_UserId', UM_UserId);
    sessionStorage.setItem('UM_UserCode', UM_UserCode);
    sessionStorage.setItem('selectedScpId', selectedScpId);

  }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId]);
  const [shipmentData, setShipmentData] = useState([]);

  const [firstFilter, setFirstFilter] = useState('');
  const [firstFilterSearch, setFirstFilterSearch] = useState('');
  const [secondFilter, setSecondFilter] = useState('');
  const [secondFilterSearch, setSecondFilterSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(9);
  // const [statusFilter, setStatusFilter] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');
  const [options, setOptions] = useState([]);


  const [firstFilterOptions, setFirstFilterOptions] = useState([
    { value: 'SHPR_ShipmentReturnCode', label: 'Return Shipment Code', disabled: false },
    { value: 'LGCM_Name', label: 'Logistic Party Name', disabled: false },
    { value: 'LGCVM_VehicleNumber', label: 'Vehicle Number', disabled: false },
  ]);

  const [secondFilterOptions, setSecondFilterOptions] = useState([
    { value: 'SHPR_ShipmentReturnCode', label: 'Return Shipment Code', disabled: false },
    { value: 'LGCM_Name', label: 'Logistic Party Name', disabled: false },
    { value: 'LGCVM_VehicleNumber', label: 'Vehicle Number', disabled: false },
  ]);

  const logAction = async (action, isError = false) => {
    try {
      const response = await fetch(`${config.API_URL}/api/log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ module: "Shipment Outward Creation:", action, userCode: UM_UserCode, isError }),
      });
      if (!response.ok) {
        throw new Error('Failed to log action');
      }
    } catch (error) {
      console.error('Error logging action:', error);
    }
  };

  useEffect(() => {
    const fetchShipmentData = async () => {
      try {
        logAction(`Fetching shipment data for company ID: ${selectedScpId}`);
        const response = await fetch(`${config.API_URL}/shipment/return/${selectedScpId}`);
        if (!response.ok) {
          throw new Error('Failed to fetch shipment data');
        }
        const data = await response.json();
        setShipmentData(data.shipmentData);
        logAction(`Shipment data fetched successfully for company ID: ${selectedScpId}`);
      } catch (error) {
        console.error('Error fetching shipment data:', error);
        logAction(`Error fetching shipment data for company ID: ${selectedScpId}. Error: ${error.message}`, true);
      }
    };

    fetchShipmentData();
  }, [selectedScpId]);

  useEffect(() => {
    const fetchEnumTypes = async () => {
      try {
        const response = await fetch(`${config.API_URL}/api/enumtype/shipment`);
        if (!response.ok) {
          throw new Error('Failed to fetch enum types');
        }
        const data = await response.json();
        setOptions(data.data);
      } catch (error) {
        console.error('Error fetching enum types:', error);
      }
    };

    fetchEnumTypes();
  }, []);


  const handlePrintPDF = async (shipmentCode) => {
    try {
      const response = await fetch(`${config.API_URL}/api/shipmentreturnpdf/${shipmentCode}`);
      const data = await response.json();

      console.log('API Response:', data); // Check the API response
      logAction(`handlePrintPDF(): Fetching PDF data for shipment code ${shipmentCode}`);

      if (!data.tableData || data.tableData.length === 0) {
        console.error('Table data is empty or not fetched correctly:', data);
        logAction('handlePrintPDF(): Table data is empty or not fetched correctly');
        return;
      }

      const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4',
      });

      const textColor = [0, 0, 0]; // Black (RGB)
      const headerTextColor = [255, 255, 255]; // White (RGB)
      const headerColor = [135, 206, 250]; // Light Blue (RGB)
      const rowColor = [255, 255, 255]; // White (RGB)

      const styles = {
        title: {
          fontSize: 24,
          color: textColor,
          fontStyle: 'bold',
          margin: { top: 20 },
          align: 'center',
        },
        detailsTable: {
          fontSize: 12,
          color: textColor,
          margin: { top: 10 },
          fillColor: rowColor,
        },
        tableHeader: {
          fontSize: 12,
          color: headerTextColor,
          fontStyle: 'bold',
          fillColor: headerColor,
        },
        tableRow: {
          fontSize: 10,
          color: textColor,
          fillColor: rowColor,
        },
      };

      const imgData = ShubhamImage;
      doc.addImage(imgData, 'PNG', 10, 10, 40, 20);

      const printedBy = `Printed By : ${UM_UserCode}`;
      const printedOn = `Printed On : ${new Date().toLocaleString()}`;
      const startX = doc.internal.pageSize.getWidth() - 50;
      const startY = 20;

      doc.setFontSize(8);
      doc.text(printedBy, startX, startY + 5, { textAlign: 'right', fontWeight: 'bold' });
      doc.text(printedOn, startX, startY, { textAlign: 'right', fontWeight: 'bold' });

      const detailsTable = [
        [{ content: 'Shipment Information', colSpan: 2, styles: { halign: 'center', fontSize: 14, fillColor: [41, 128, 185], textColor: [255, 255, 255] } }],
        ['Shipment Type', data.shipmentDetails.SHPR_ShipmentType],
        ['Shipment Date', data.shipmentDetails.SHPR_ShipmentDate],
        ['Shipment Code', `${shipmentCode}`],
        ['Logistic Party Name', data.shipmentDetails.LGCM_Name],
        ['Vehicle Number', data.shipmentDetails.LGCVM_VehicleNumber || "N/A"],
        ['SCP Name', data.shipmentDetails.SCPM_Name],
        ['Shipment Status', data.shipmentDetails.StatusDescription],
        // ['Routing for Shipment Location', data.shipmentDetails.RUTL_Name],
      ];

      const shipmentInfo = [
        [{ content: 'Shipment Details', colSpan: 2, styles: { halign: 'center', fontSize: 14, fillColor: [41, 128, 185], textColor: [255, 255, 255] } }]
      ];

      doc.autoTable({
        head: [],
        body: detailsTable,
        startY: 40,
        theme: 'grid',
        styles: {
          ...styles.detailsTable,
          cellPadding: 2,
          valign: 'middle',
          halign: 'left',
        },
      });

      const headers = ['Shipment Code', 'Product Code', 'Product Name', 'Received Qty', 'Return Qty'];

      const tableData = data.tableData.map(row => [
        row['Shipment Code'],
        row['Product Code'],
        row['Product Name'],
        row['Received Qty'],
        row['Return Qty']
      ]);

      doc.autoTable({
        head: [],
        body: shipmentInfo,
        startY: doc.autoTable.previous.finalY + 7,
        theme: 'grid',
        styles: {
          cellPadding: 2,
          valign: 'middle',
          halign: 'left',
        },
      });

      doc.autoTable({
        head: [headers],
        body: tableData,
        startY: doc.autoTable.previous.finalY + 0,
        theme: 'grid',
        headStyles: {
          fillColor: [41, 128, 185],
          textColor: [255, 255, 255],
          lineWidth: 0.25,
          cellPadding: 2,
          valign: 'middle',
          halign: 'left',
          rowHeight: 8,
          border: {
            top: { style: 'solid', width: 0.25, color: [0, 0, 0] },
          },
        },
        styles: {
          cellPadding: 2,
          valign: 'middle',
          halign: 'left',
        },
      });
      addFooter(doc);
      doc.save(`Shipment_${shipmentCode}.pdf`);
      logAction(`handlePrintPDF(): PDF generated successfully for shipment code ${shipmentCode}`);
    } catch (error) {
      console.error('Error generating PDF:', error);
      logAction(`handlePrintPDF(): Error generating PDF for shipment code ${shipmentCode}`);
    }
  };

  const addFooter = (doc) => {
    const totalPages = doc.internal.getNumberOfPages();

    for (let i = 1; i <= totalPages; i++) {
      // Go to page i
      doc.setPage(i);

      // Set text alignment to left
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0); // Black color
      doc.text('Developed by : Shubham Automation Pvt. Ltd.', 10, doc.internal.pageSize.getHeight() - 10); // at left side of the page

      // Add page number to the right side of the page
      doc.text(`Page ${i} of ${totalPages}`, doc.internal.pageSize.getWidth() - 20, doc.internal.pageSize.getHeight() - 10, { align: 'right' });
      //  doc.text(`Page ${i}`, doc.internal.pageSize.getWidth() - 20, doc.internal.pageSize.getHeight() - 10, { align: 'right' });
    }
  };

  useEffect(() => {
    // Whenever any of the filters change, reset to the first page
    setCurrentPage(1);
  }, [firstFilterSearch, secondFilterSearch, selectedStatus]);
  const handleFirstFilterChange = (event) => {
    const value = event.target.value;
    setFirstFilter(value);
    setFirstFilterSearch('');
    logAction("handleFirstFilterChange(): A column selected in the first filter");

    const updatedSecondOptions = secondFilterOptions.map(option => ({
      ...option,
      disabled: option.value === value
    }));
    setSecondFilterOptions(updatedSecondOptions);
    logAction("handleFirstFilterChange(): Column selected in the first filter gets disabled in the second filter");
  };

  const handleSecondFilterChange = (event) => {
    const value = event.target.value;
    setSecondFilter(value);
    setSecondFilterSearch('');
    logAction("handleSecondFilterChange(): A column selected in the second filter");
    const updatedFirstOptions = firstFilterOptions.map(option => ({
      ...option,
      disabled: option.value === value
    }));
    setFirstFilterOptions(updatedFirstOptions);
    logAction("handleSecondFilterChange(): Column selected in the second filter gets disabled in the first filter");
  };

  const handlestatuschange = (e) => {
    const newStatus = (e.target.value); // Ensure newStatus is treated as a string and trimmed
    console.log('New Status:', newStatus);
    setSelectedStatus(newStatus);


    logAction(`HandleStatusChange(): ${newStatus}`);
  };


  const filteredListData = shipmentData.filter(item => {
    const firstFilterValue = item[firstFilter];
    const secondFilterValue = item[secondFilter];

    // Convert SHPR_Status to string and compare after trimming and ensuring consistent types
    const itemStatus = String(item.SHPR_Status).trim();

    // Check if item status matches selectedStatus (if selectedStatus is not empty)
    const matchesStatusFilter = !selectedStatus || itemStatus === selectedStatus.toString().trim();

    const matchesFirstFilter =
      (!firstFilter || !firstFilterSearch) ||
      (firstFilter !== 'SHPR_Status' && String(firstFilterValue).toLowerCase().includes(firstFilterSearch.toLowerCase()));

    const matchesSecondFilter =
      (!secondFilter || !secondFilterSearch) ||
      (secondFilter !== 'SHPR_Status' && String(secondFilterValue).toLowerCase().includes(secondFilterSearch.toLowerCase()));

    // Combine all filters
    return matchesFirstFilter && matchesSecondFilter && matchesStatusFilter;
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredListData.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <div className='main_container'>
        <h1 className='formHeading'>Shipment Return List</h1>

        <div className="filter-container">
          <div className='select-container_list'>
            <CustomDropdown
              options={firstFilterOptions}
              value={firstFilter}
              onChange={handleFirstFilterChange}
              name="firstFilter"
              placeholder="--Select--"
              idKey="value"
              displayKey="label"
            />

          </div>
          <input className='search-input' type="text" value={firstFilterSearch} onChange={(e) => setFirstFilterSearch(e.target.value)} placeholder={`Search`} />

          <div className='select-container_list'>
            <CustomDropdown
              options={secondFilterOptions}
              value={secondFilter}
              onChange={handleSecondFilterChange}
              name="secondFilter"
              placeholder="--Select--"
              idKey="value"
              displayKey="label"
            />

          </div>
          <input className='search-input' type="text" value={secondFilterSearch} onChange={(e) => setSecondFilterSearch(e.target.value)} placeholder={`Search`} />

          <div className='select-container_list'>
            <CustomDropdown
              options={options}
              value={selectedStatus}
              onChange={handlestatuschange}
              name="orderStatus"
              placeholder="--Select Status--"
              idKey="id"
              displayKey="name"
            />
          </div>

        </div>
        <div className="ptable-wrapper">
          <table className="ptableClass">
            <thead className="">
              <tr>
                <th scope="col">Sr. No.</th>
                <th scope="col">Return Shipment Code</th>
                <th scope="col">Logistic Party Name</th>
                <th scope="col">Vehicle Number</th>
                <th scope="col">Status</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            {filteredListData.length === 0 ? (
              <tbody >
                <tr>
                  <td colSpan="9">No Records Found</td> {/* Set colSpan to match the number of columns */}
                </tr>
              </tbody>
            ) : (
              <tbody>
                {currentItems.map((shipment, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{shipment.SHPR_ShipmentReturnCode}</td>
                    <td>{shipment.LGCM_Name}</td>
                    <td>{shipment.LGCVM_VehicleNumber || 'N/A'}</td>
                    <td>{shipment.StatusDescription}</td>
                    <td style={{ display: 'none' }}>{shipment.SHPR_Status}</td>
                    <td>
                      {shipment.StatusDescription === 'Created' && (
                        <>
                          <Link to={`/shipmentreturnedit/${shipment.SHPR_ShipmentReturnCode}`}>
                            <img title='Edit' src={Icon3} alt="Edit" />
                          </Link>
                        </>)}

                      <Link to={`/shipmentreturnview/${shipment.SHPR_ShipmentReturnCode}`} >
                        <img title='View' className='ms-2' src={eye} alt="View" style={{ width: '20px', height: '20px' }} />
                      </Link>
                      <img title='Print' className='printicon' src={Icon8} onClick={() => handlePrintPDF(shipment.SHPR_ShipmentReturnCode)}></img>
                    </td>
                  </tr>
                ))}
              </tbody>
            )}

          </table>
        </div>
        {/* Pagination */}
        {/* <ul className="pagination">
          <li className={currentPage === 1 ? "page-item disabled" : "page-item"}>
            <button className="page-linkd" onClick={() => paginate(currentPage - 1)}>Previous</button>
          </li>
          {Array.from({ length: Math.ceil(filteredListData.length / itemsPerPage) }, (_, index) => (
            <li key={index} className={currentPage === index + 1 ? "page-item active" : "page-item"}>
              <button className="page-linkd" onClick={() => paginate(index + 1)}>{index + 1}</button>
            </li>
          ))}
          <li className={currentPage === Math.ceil(filteredListData.length / itemsPerPage) ? "page-item disabled" : "page-item"}>
            <button className="page-linkd" onClick={() => paginate(currentPage + 1)}>Next</button>
          </li>
        </ul> */}
        <ul className="pagination">
          {/* First Page Button */}
          <li className={currentPage === 1 || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
            <button className="page-linkd" onClick={() => paginate(1)}>First</button>
          </li>

          {/* Previous Page Button */}
          <li className={currentPage === 1 || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
            <button className="page-linkd" onClick={() => paginate(currentPage - 1)}>Previous</button>
          </li>

          {/* Page Numbers */}
          {Array.from({ length: Math.ceil(filteredListData.length / itemsPerPage) }, (_, index) => (
            <li key={index} className={currentPage === index + 1 ? "page-item active" : "page-item"}>
              <button className="page-linkd" onClick={() => paginate(index + 1)}>{index + 1}</button>
            </li>
          ))}

          {/* Next Page Button */}
          <li className={currentPage === Math.ceil(filteredListData.length / itemsPerPage) || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
            <button className="page-linkd" onClick={() => paginate(currentPage + 1)}>Next</button>
          </li>

          {/* Last Page Button */}
          <li className={currentPage === Math.ceil(filteredListData.length / itemsPerPage) || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
            <button className="page-linkd" onClick={() => paginate(Math.ceil(filteredListData.length / itemsPerPage))}>Last</button>
          </li>
        </ul>

      </div>
      <Link to={`/dashboard/shipmentreturn`} className='back_btn' >BACK
      </Link>
    </>
  );
};

export default ShipmentReturnList;